import { useCallback, useRef } from 'react';
import { IHandleCleanupParams, TInputState } from '../types';
import { reduce } from 'lodash';
import { THandleCleanup } from './types';

export const useHandleCleanup = ({
  inputs,
  setInputs,
}: IHandleCleanupParams): THandleCleanup => {
  const inputsRef = useRef(inputs);
  inputsRef.current = inputs;

  return useCallback(() => {
    const current = inputsRef.current;
    setInputs(
      reduce(
        current,
        (r, v, k) => ({
          ...r,
          [k]: { ...v, value: undefined, touched: false, errors: undefined },
        }),
        {} as Record<string, TInputState>
      )
    );
  }, [setInputs]);
};
